import { configureStore } from '@reduxjs/toolkit';
import themeSettingSlice from './themeSettingSlice';
import sidebarSlice from './sidebarSlice';
import otpReducer from './reducer/OtpReducer'
import alertReducer from './reducer/AlertReducer'
import loadingReducer from './reducer/LoadingReducer'
import { AdminReducer } from './reducer/AdminReducer'
import { UserReducer } from './reducer/UserReducer'
import { TaskReducer } from './reducer/TaskReducer'


const store = configureStore({
  reducer: {
    themeSetting: themeSettingSlice,
    sidebarSlice: sidebarSlice,
    otp: otpReducer,
    alert: alertReducer,
    loading:loadingReducer,
    admin: AdminReducer,
    user:UserReducer,
    task:TaskReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export default store;
